// extracted by mini-css-extract-plugin
export var completionBody = "_lo-2";
export var completionCard = "_lo-0";
export var completionFooter = "_lo-3";
export var completionTitle = "_lo-1";